import { useTranslation } from 'react-i18next';

import type { Location } from '../../../shared/types';
import { AutocompleteMultipleField, type AutocompleteMultipleFieldProps } from '../../fields/AutocompleteMultipleField';
import type { DailyTasksFormFilerValue } from '../lib/types';

export type LocationFieldProps = Omit<
  AutocompleteMultipleFieldProps<DailyTasksFormFilerValue, 'locations', Location>,
  'name' | 'label' | 'getOptionLabel' | 'renderOption'
>;

export const LocationField = (props: LocationFieldProps) => {
  const { t } = useTranslation();

  return (
    <AutocompleteMultipleField
      {...props}
      name='locations'
      getOptionLabel={(location) => location.title}
      label={t('location')}
      renderOption={(liProps, location) => <li {...liProps}>{location.title}</li>}
    />
  );
};
